<template>
  <div class="pagemain">
    <div class="iframe">
      <iframe
        style="width: 100%; height: 100%; border: none"
        src="https://alidocs.dingtalk.com/i/p/2rqGdo13VpYgxmaV"
      ></iframe>
    </div>
    <div class="xuqiu" @click="jianyi_show = true">
      <div>
        <img class="kefu_img" src="@/assets/image/user/kefu.png" alt="" />
      </div>
      <div class="xuqiu_txt">给大象提建议</div>
    </div>

    <Modal
      width="600"
      v-model="jianyi_show"
      title="大象-提交反馈建议"
      :footer-hide="true"
      :mask-closable="false"
    >
      <div class="select_div">
        <div class="select_div_title">工单类型：</div>
        <Select v-model="service_type" style="width: 200px" filterable>
          <Option v-for="item in service_type_list" :value="item" :key="item">{{
            item
          }}</Option>
        </Select>
      </div>
      <div class="select_div">
        <div class="select_div_title">详细描述：</div>
        <div class="jianyi_div">
          <Input
            v-model="jianyi_text"
            type="textarea"
            :rows="2"
            show-word-limit
            maxlength="250"
            placeholder="在这里输入您的问题或遇到的BUG.."
          />
        </div>
      </div>
      <div class="select_div">
        <div class="select_div_title">相关截图：</div>

        <div>
          <div class="img_div_main" v-if="upload_file_list.length > 0">
            <div v-for="(item, i) in upload_file_list" :key="i" class="img_div">
              <Icon
                type="ios-close-circle"
                class="del_img"
                color="red"
                size="20"
                @click="del_upload_img(item, i)"
              />
              <img :src="item.url" alt="" class="upload_file_img" />
              <div>
                {{ item.filename }}
              </div>
            </div>
          </div>
          <div class="upload_btn_div">
            <Upload
              :action="upload_url"
              :on-success="upload_success"
              :show-upload-list="false"
            >
              <Button icon="ios-cloud-upload-outline">上传截图或文件</Button>
            </Upload>
          </div>
        </div>
      </div>
      <div class="select_div" v-if="is_super_admin == 1">
        <div class="select_div_title">建议人：</div>
        <Select v-model="select_propounder" style="width: 200px" filterable>
          <Option
            v-for="item in user_list_data"
            :value="item.user_id"
            :key="item.user_id"
            >{{ item.name }}</Option
          >
        </Select>
      </div>

      <div>
        <div class="submit_div">
          <!-- <div v-if="is_super_admin == 1">
            <div></div>
            <span>建议人：</span>
            <Select v-model="select_propounder" style="width: 120px" filterable>
              <Option
                v-for="item in user_list_data"
                :value="item.user_id"
                :key="item.user_id"
                >{{ item.name }}</Option
              >
            </Select>
          </div> -->

          <Button :loading="submit_loading" type="primary" @click="submit_jianyi"
            >确认提交反馈</Button
          >
        </div>
      </div>
    </Modal>

    <Modal
      width="400"
      v-model="bind_wx_show"
      :mask-closable="false"
      title="绑定微信通知"
      :closable="true"
      @on-visible-change="bind_weixin_show_change"
      :footer-hide="true"
    >
      <div class="bind_wx_status_title">
        用户未绑定微信，无法提交！ <br />
        请使用微信扫一扫关注公众号绑定
        <br />
      </div>
      <div class="bing_qr_img_div">
        <div class="bind_qr_img">
          <img :src="bind_wx_qr_img" alt="" class="" style="width: 100%; height: 100%" />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { open_new_page, http } from "@/utils/http";

export default {
  name: "help",
  data() {
    return {
      //   user_info_data: {
      //     name: "",
      //     phone: "",
      //     avatar: "",
      //   },
      submit_loading: false,
      bind_info: {
        user_info: {
          name: "",
          phone: "",
          avatar: "",
          team_name: "",
          dep_name: "",
        },
        bind_dingding: false,
        bind_weixin_mp: false,
      },
      bind_weixin_mp_data: {},

      //   绑定微信弹窗
      bind_wx_show: false,
      bind_wx_qr_img: "",

      // 绑定钉钉弹窗
      bind_dingding_data: {},
      bind_dingding_show: false,
      bind_dingding_qr_img: "",
      bind_dingding_qr_loading: false,

      //
      upload_url:
        process.env.VUE_APP_HOST +
        "/staff/suggest/upload_file?token=" +
        this.$cookies.get("dx_token"),
      jianyi_show: false,
      jianyi_text: "",
      upload_file_list: [],

      user_list_data: [],
      select_propounder: "",
      is_super_admin: 0,

      service_type: "大象BUG修复",
      service_type_list: ["大象BUG修复", "大象新增功能", "大象意见收集"],
      bind_wx_show: false,
      bind_wx_qr_loading: false,
      bind_wx_qr_img: "",
    };
  },
  mounted() {
    var query = this.$route.query;
    if (query.jianyi == 1) {
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 先拷贝一个一模一样的对象
      delete newQuery.jianyi; //再删除page
      this.$router.replace({ query: newQuery });
      this.jianyi_show = true;
    }
    this.get_user_list();
  },

  methods: {
    //删除图片
    del_upload_img(item, i) {
      console.log(i);
      this.upload_file_list.splice(i, 1);
    },

    upload_success(e) {
      console.log(e);
      if (e.code == 0) {
        this.$Message.success(e.msg);
        this.upload_file_list.push(e.data);
      } else {
        this.$Message.error(e.msg);
      }
    },

    submit_jianyi() {
      var file_list = [];
      for (var i = 0; i < this.upload_file_list.length; i++) {
        var object_name = this.upload_file_list[i]["object_name"];
        file_list.push(object_name);
      }

      //   if (file_list.length == 0) {
      //     this.$Message.error("请至少上传一张截图");
      //     return;
      //   }

      var that = this;
      var obj = {
        content: this.jianyi_text,
        file_list: file_list,
        propounder: this.select_propounder,
      };
      that.submit_loading = true;
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/suggest/suggest_submit",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.jianyi_show = false;
          } else {
            if (res.code == 412) {
              that.bind_wx_show = true;
              that.bind_wx_qr_img = res.data.qr_b64;
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
          }
          that.submit_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
          that.submit_loading = false;
        });
    },

    get_user_list() {
      var that = this;
      var obj = {};
      http(
        "post",
        process.env.VUE_APP_MESSAGE_URL + "/staff/suggest/user_list",
        obj,
        true,
        "staff"
      )
        .then((res) => {
          if (res.code == 0) {
            that.user_list_data = res.data.user_list;
            that.is_super_admin = res.data.is_super_admin;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },
  },
};
</script>

<style scoped>
.bind_wx_status_title {
  font-size: 14px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
}
.bing_qr_img_div {
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
  position: relative;
}
.bind_qr_img {
  width: 150px;
  height: 150px;
  border: 1px solid #989898;
}
.select_div {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.upload_file_img {
  width: 100%;
  height: 100%;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.submit_div {
  margin-top: 20px;
  display: flex;
  justify-content: end;
}

.img_div_main {
  display: flex;
  flex-wrap: wrap;

  margin-bottom: 40px;
}

.upload_btn_div {
  display: flex;
  justify-content: flex-start;
}

.img_div {
  width: 70px;
  height: 70px;
  position: relative;
  margin: 0 10px 10px 0;
}

.del_img {
  position: absolute;
  right: 1px;
  top: 1px;
  border-radius: 50%;
  border: 1px solid #ccc;
  cursor: pointer;
}

.del_img:hover {
  border: 1px solid #3b3b3b;
}

.jianyi_div {
  /* height: 110px; */
  width: 100%;
}

.select_div_title {
  flex-shrink: 0;
  width: 100px;
}

@keyframes moveRight {
  0% {
    transform: translateY(0);
    background: #6702ff;
  }
  50% {
    transform: translateY(80px);
    background: #ff5a02;
  }

  100% {
    transform: translateY(0px);
  }
}

.kefu_img {
  width: 60px;
  height: 60px;
  position: relative;
  top: -5px;
}

.xuqiu_txt {
  font-size: 13px;
  font-weight: 300;
  letter-spacing: 1px;
  position: relative;
  top: -10px;
}

.xuqiu {
  animation: moveRight 4s infinite;
}

.xuqiu {
  cursor: pointer;
  box-shadow: 0 0 5px #e8e4e4;
  width: 110px;
  height: 100px;
  color: #fff;
  background: #0676ff;
  border-radius: 10px;
  padding: 10px;
  text-align: center;
  position: absolute;
  right: 30px;
  bottom: 200px;
}

.xuqiu:hover {
  animation-play-state: paused;
}

.iframe {
  height: calc(100vh - 0px);
  overflow: hidden;
  background: #fff;
  padding: 0 0x;
}

.pagemain {
  width: calc(100vw - 120px);
  background: #ececec;
  min-height: 100vh;
}
</style>
